<template>
  <div>
    <div class="profile__charts__container">
      <div class="sales_report__container">
        <ReportFilterForm
          v-model="params"
          range-date-label="Travel Range Dates"
          :user-picker="false"
        />
        <div class="d-flex">
          <BaseButton
            ref="searchQuotesButton"
            size="large"
            action="principal"
            class="w-50 mx-1"
            :loading="loading"
            @click="downloadQuote(params)"
          >
            <b-icon slot="icon" icon="download" custom-size="mdi-18px" />
            <p slot="text">Quotes with closed services</p>
          </BaseButton>
          <BaseButton
            size="large"
            action="principal"
            class="w-50 mx-1"
            :loading="loadingSpent"
            @click="downloadSpent(params)"
          >
            <b-icon slot="icon" icon="download" custom-size="mdi-18px" />
            <p slot="text">Quotes with time spent</p>
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ReportFilter from "@/components/reports/ReportFilter.vue";
import ReportFilterForm from "@/components/reports/ReportFilterForm.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import excel from "@/utils/excel";
import reportService from "@/services/reports";

export default {
  name: "QuoteReport",
  components: { BaseButton, ReportFilterForm, ReportFilter },
  data() {
    return {
      isLoadingUsers: false,
      params: null,
      loading: false,
      loadingSpent: false,
    };
  },
  computed: {
    ...mapGetters({
      authData: "auth/getAuthData",
      salesReport: "reports/getSalesReport",
      userSummary: "reports/getUserSummary",
      clients: "client/getClients",
      authUser: "auth/getAuthUserData",
      users: "users/getUsers",
    }),
  },
  methods: {
    async downloadSpent(params) {
      this.loadingSpent = true;

      const adaptedParams = {
        client: this.params?.clients?.map((client) => client.id),
        from: params?.from,
        to: params?.to,
        user: params?.users?.map((user) => user.id),
        spent: 1,
        itinerary: params?.itinerary,
      };

      try {
        const workbook = excel.newWorkbook();

        const detailResponse = await reportService.loadQuotes(adaptedParams);

        excel.addNewSheet(workbook, "DETAIL", detailResponse.data);

        const filename = `REPORT OF QUOTES WITH TIME SPENT - ${adaptedParams.from} to ${adaptedParams.to}`;

        await excel.download(workbook, filename);
      } catch (e) {
        console.error(e);
        this.showAlertError();
      }

      this.loadingSpent = false;
    },
    showAlertError() {
      this.$buefy.toast.open({
        duration: 5000,
        message:
          "Upps! There was an error downloading your report. Please try again.",
        position: "is-top",
        type: "is-danger",
      });
    },
    async downloadQuote(params) {
      this.loading = true;

      const adaptedParams = {
        client: this.params?.clients?.map((client) => client.id),
        from: params?.from,
        to: params?.to,
        user: params?.users?.map((user) => user.id),
        itinerary: params?.itinerary,
        service: params?.service,
      };

      try {
        const workbook = excel.newWorkbook();

        const detailResponse = await reportService.loadQuotes(adaptedParams);

        excel.addNewSheet(workbook, "DETAIL", detailResponse.data);

        const filename = `REPORT OF QUOTES WITH CLOSED SERVICES - ${adaptedParams.from} to ${adaptedParams.to}`;

        await excel.download(workbook, filename);
      } catch (e) {
        console.error(e);
        this.showAlertError();
      }

      this.loading = false;
    },
  },
};
</script>
